import http from './http.config'

export type MembershipPackage = {
  id: string | number
  label: string
  highlight: string
  features: string[]
  price_monthly: string | number
  price_yearly: string | number
}

export const createVendorRequest = (formData: FormData) =>
  http.post('/vendor-applications/store', formData).then((res) => res.data)
export const sendVendorRequest = (payload: Record<string, any>) =>
  http.post('/vendor-applications/send', payload).then((res) => res.data)
export const sendVendorRequestWithoutPrice = (payload: Record<string, any>) =>
  http.post('/vendor-applications/send-without-price', payload).then((res) => res.data)

export const getMembershipPackageList = () =>
  http.get('/company/membership-plans').then((res) => res.data)

export const getCompanyPlan = (id: string | number) =>
  http.get(`/company/${id}/membership-plans`).then((res) => res.data);

// Vendor Membership Payment APIs
export const createVendorMembershipIntent = (payload: Record<string, unknown>) =>
  http.post("/vendor-memberships/intent", payload).then((res) => res.data);

export const finalizeVendorMembership = (payload: Record<string, unknown>) =>
  http
    .post("/vendor-memberships/finalize", payload)
    .then((res) => res.data);

export const chargeSavedVendorMembershipCard = (payload: Record<string, unknown>) =>
  http
    .post("/vendor-memberships/charge-saved-card", payload)
    .then((res) => res.data);

export const fetchServiceGroups = () =>
  http.get('/service-groups').then((res) => res.data)
